import { GetSellOrdersProps } from "@/services/sell-order.service";
import dayjs, { Dayjs } from "dayjs";

export interface SOFRProps {
  order_date?: Dayjs;
  account_owner: string;
  order_amount: string;
  fixation_type: string[];
  grain: number
  ton: number
  estado?: string[];
}

export const getSellOrderFilter = (
  event: SOFRProps,
): Partial<GetSellOrdersProps> => {
  let order_amount;

  if (event?.order_amount) {
    const cleaned = event?.order_amount
      .replaceAll(/[^0-9,.-]/g, "")
      .replaceAll(".", "")       
      .replaceAll(",", "."); 

    order_amount = Number.parseFloat(cleaned).toFixed(2);
  }

  return {
    ...(event?.order_date && dayjs(event?.order_date).isValid()
      ? {
          fecha: dayjs(event?.order_date).toISOString(),
        }
      : {}),
    ...(event?.estado?.length
      ? {
          estado: event?.estado,
        }
      : {}),
    ...(event?.account_owner
      ? {
          titular: event?.account_owner,
        }
      : {}),
    ...(event?.order_amount && order_amount
      ? {
          monto: Number(order_amount),
        }
      : {}),
    ...(event?.fixation_type
      ? {
          tipoFijacion: event?.fixation_type,
        }
      : {}),
      ...(event?.ton ? {
        toneladas: Number(event?.ton)
      } : {}),
      ...(event.grain ? {
        grano: event?.grain 
      } : {})
  };
};
